var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":_vm.maxWidth},on:{"input":function($event){return _vm.emitInput($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }